import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Box, CircularProgress, Menu, MenuItem, menuClasses } from '@mui/material';

import { Triggered_Message_Status } from '@occc/graphql';

import { allStatuses, titleByStatus } from '../../triggered-messages.constants';
import { StatusBadge } from '../../components/status-badge';

type MessageStatusDraftSelectProps = {
  status: Triggered_Message_Status;
  isBusy?: boolean;
  onStatusChange: (status: Triggered_Message_Status) => void;
};

export const MessageStatusDraftSelect = (props: MessageStatusDraftSelectProps) => {
  const { status, isBusy, onStatusChange } = props;

  return (
    <PopupState variant='popover' popupId='message-status-menu'>
      {(popupState) => (
        <>
          <Box display='flex' alignItems='center' gap={1}>
            <StatusBadge
              {...bindTrigger(popupState)}
              {...(isBusy && {
                sx: { opacity: 0.5, pointerEvents: 'none' },
              })}
              isEditable
              status={status}
            />
            {isBusy ? <CircularProgress size='14px' color='secondary' /> : null}
          </Box>
          <Menu
            {...bindMenu(popupState)}
            sx={{ [`& .${menuClasses.paper}`]: { mt: 0.5, minWidth: 180 } }}
          >
            {allStatuses.map((currentStatus) => (
              <MenuItem
                key={currentStatus}
                selected={currentStatus === status}
                onClick={() => {
                  onStatusChange(currentStatus);
                  popupState.close();
                }}
              >
                {titleByStatus[currentStatus]}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};
